<template>
  <div class="footer-box">
    <su-container>
      <div class="footer-top">
        <!-- 移动端折叠菜单 -->
        <div class="mobile-footer" v-if="isPhone">
          <div v-for="(section, index) in footerSections" :key="index" class="mobile-footer-section">
            <div class="mobile-footer-title" @click="toggleSection(index)">
              {{ section.title }}
              <i :class="['el-icon-arrow-down', {'is-active': activeSection === index}]"></i>
            </div>
            <div class="mobile-footer-content" v-show="activeSection === index">
              <div v-for="(item, idx) in section.items" :key="idx" class="mobile-footer-item" @click="pathFn(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- 公司信息部分(移动端) -->
          <div class="company-info-mobile">
            <img class="logo-img" referrerpolicy="no-referrer"
              src="https://lanhu-oss-2537-2.lanhuapp.com/pspw233xlq4hrss6om3k3ozqs0l2m930m5i31bab081-f14e-4cbe-86c9-6d88c22c1ddf" />
            <div class="company-name">{{ $t('CommonFooter.琴航（广东横琴）科技有限公司') }}</div>
            <div class="contact-item">
              <i class="el-icon-phone-outline"></i>
              <div class="contact-item_main">{{ $t('CommonFooter.400-000-0000') }}</div>
            </div>
            <div class="contact-item">
              <i class="el-icon-location-outline"></i>
              <div class="contact-item_main">{{ $t('CommonFooter.地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2') }}</div>
            </div>
            <div class="contact-item">
              <i class="el-icon-message"></i>
              <div class="contact-item_main" href="mailto:Kinghang@e99.cn">{{ $t('CommonFooter.contactEmail') }}</div>
            </div>
          </div>
        </div>
        
        <!-- PC端布局 -->
        <div class="flex ju-sb" v-if="!isPhone">
          <div class="footer-column" v-for="(item,i) in footerSections" :key="i">
            <div class="column-title">{{ item.title }}</div>
            <h1 class="column-item" v-for="(lis, index) in item.items" @click="pathFn(lis)" :title="lis.name">{{ lis.name }}</h1>
          </div>
          
          <div class="company-info">
            <img class="logo-img" referrerpolicy="no-referrer"
              src="https://lanhu-oss-2537-2.lanhuapp.com/pspw233xlq4hrss6om3k3ozqs0l2m930m5i31bab081-f14e-4cbe-86c9-6d88c22c1ddf" />
            <div class="company-name">{{ $t('CommonFooter.琴航（广东横琴）科技有限公司') }}</div>
            <div class="contact-item">
              <i class="el-icon-location-outline"></i>
              <div class="contact-item_main">{{ $t('CommonFooter.地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2') }}</div>
            </div>
            <div class="contact-item">
              <i class="el-icon-message"></i>
              <div class="contact-item_main" @click="emailFn">{{ $t('CommonFooter.contactEmail') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="lines"></div>
      <div class="bottom-box txt-cen">
        <span>{{ $t('CommonFooter.Copyright © 2025 琴航（广东横琴）科技有限公司') }}</span>
        <span>{{ $t('CommonFooter.版权所有') }} | {{ $t('CommonFooter.使用条款') }} | <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">{{ $t('CommonFooter.粤ICP备2025393208号-1') }}</a> | {{ $t('CommonFooter.网站地图') }}</span>
      </div>
    </su-container>
	
	<el-dialog :title="$t('CommonFooter.联系我们')" center :visible.sync="phoneOpen" :modal-append-to-body="true" :append-to-body="true" width="360px">
		<div class="txt-cen">
			<h2>{{$t('CommonFooter.contactEmail')}}</h2>
		</div>
		<div slot="footer" class="flex ju-cn">
			<el-button type="info" class="saveBtn" @click="phoneOpen = false">{{$t('shop-list.取消')}}</el-button>
		</div>
	</el-dialog>
	
  </div>
</template>
<script>
import { i18n } from '@/utils/i18n'; // 引入 i18n 实例
import {
	textsList,
	textsDetail,
} from '@/api/zhao'
import {
  productCategoryList
} from '@/api/api'
export default {
  name: 'CommonFooter',
  i18n, // 使用 i18n 实例
  data() {
    return {
		phoneOpen: false,
      isPhone: false,
      activeSection: null,
      footerSections: [
        {
          title: this.$t('CommonFooter.热门产品分类'),
          items: [
            {name:this.$t('CommonFooter.元器件'),id:'1920648354331021313',type:2},
            {name:this.$t('CommonFooter.应急装备'),id:'1920648389835804674',type:2},
            {name:this.$t('CommonFooter.光学传感器'),id:'1920648617456488450',type:2},
            {name:this.$t('CommonFooter.mems'),id:'1920648850739482626',type:2},
            {name:this.$t('CommonFooter.复合材料'),id:'1920649023720968194',type:2},
            {name:this.$t('CommonFooter.低空飞行器'),id:'1920648313646272513',type:2},
            {name:this.$t('CommonFooter.其他'),id:'1920715625455865858',type:2},
          ]
        },
        {
          title: this.$t('CommonFooter.帮助与支持'),
          items: [
			  {name:this.$t('CommonFooter.平台规则'),id:'',type:1},
			  {name:this.$t('CommonFooter.常见问题'),id:'',type:1},
			  {name:this.$t('CommonFooter.安全保障'),id:'',type:1},
			  {name:this.$t('CommonFooter.联系我们'),id:'',type:0},
          ]
        },
        {
          title: this.$t('CommonFooter.关于琴航'),
          items: [
			  {name:this.$t('CommonFooter.加入琴航'),id:'',type:1},
			  {name:this.$t('CommonFooter.可持续发展'),id:'',type:1},
			  {name:this.$t('CommonFooter.廉洁举报'),id:'',type:1},
          ]
        },
        {
          title: this.$t('CommonFooter.新闻动态'),
          items: [
			  {name:this.$t('CommonFooter.行业动态'),id:'',type:1},
			  {name:this.$t('CommonFooter.最新科技'),id:'',type:1},
          ]
        }
      ],
	  newList: [],
    }
  },
  created() {
    this.checkMobile()
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkMobile)
	
	textsList().then(res=>{
		console.log('平台信息', res)
		this.newList = res.data
	})
    // 获取分类列表
    productCategoryList().then((res) => {
      let arr = res.data.slice(0,6)
      this.footerSections[0].items = arr.map(item=>{
        return {
          name: item.label,
          id: item.id,
          type: 2
        }
      })
      console.log('分类原始数据', arr)
    })
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    emailFn(){
      try {
        window.location.href = 'mailto:Kinghang@e99.cn';
      } catch (e) {
        console.error('邮件客户端未配置:', e);
        // this.$message({
        //   message: '邮件客户端未配置',
        //   type: 'error'
        // })
        // 备用方案：跳转网页版邮箱
        window.open('https://mail.example.com?to=Kinghang@e99.cn');
      }
    },
	  pathFn(item){
		  if(item.type == 0){
			  // this.phoneOpen = true
			  // this.$router.push('/reservation')
        this.$router.push('/ContactUs')
		  }else if(item.type == 1){
			  this.$router.push('/news-texts?title=' + item.name)
		  }else if(item.type == 2){
			  this.$router.push('/product-list?type=' + item.id + '&name=&level=0')
		  }
	  },
    // 判断是否移动端
    checkMobile() {
      this.isPhone = window.innerWidth < 992 ? true : false
    },
    // 切换移动端折叠部分
    toggleSection(index) {
      if (this.activeSection === index) {
        this.activeSection = null
      } else {
        this.activeSection = index
      }
    }
  },
}
</script>
<style lang="less" scoped>
  .footer-box {
    box-sizing: border-box;
    background-color: #FFFFFF;
    color: #333333;
    padding-top: 50px;
    border-top: 1px solid #f1f1f1;
    .footer-top{
      display: flex;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .ju-sb {
      justify-content: space-between;
    }

    .logo-img {
      height: 44px;
      margin-bottom: 15px;
    }

    .footer-column {
      display: flex;
      flex-direction: column;
    }

    .column-title {
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .column-item {
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      line-height: 30px;
      cursor: pointer;
      &:hover {
        color: var(--primary-color);
      }
    }

    .company-info {
      display: flex;
      flex-direction: column;
      max-width: 300px;
    }

    .company-name {
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 28px;
      margin-bottom: 15px;
    }

    .contact-item {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 10px;
        color: #333333;
        font-size: 16px;
      }
      .contact-item_main{
        flex: 1;
        text-decoration: none;

      }
    }

    .lines {
      height: 1px;
      background-color: #E5E5E5;
      margin: 30px 0;
    }

    .bottom-box {
      font-family: PingFang SC;
      font-weight: 300;
      font-size: 14px;
      color: #999999;
      display: flex;
      flex-direction: column;
      padding-bottom: 30px;
      
      span {
        display: block;
        line-height: 24px;
      }
    }
    
    /* 移动端样式 */
    .mobile-footer {
      width: 100%;
      display: flex;
      flex-direction: column;
      
      &-section {
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: 15px;
      }
      
      &-title {
        font-weight: 500;
        font-size: 18px;
        color: #333;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        
        i {
          transition: transform 0.3s ease;
          font-size: 16px;
          
          &.is-active {
            transform: rotate(180deg);
          }
        }
      }
      
      &-content {
        padding: 5px 0 15px;
      }
      
      &-item {
        font-size: 14px;
        color: #666;
        padding: 8px 0;
        padding-left: 10px;
        cursor: pointer;
        
        &:hover {
          color: var(--primary-color);
        }
      }
    }
    
    .company-info-mobile {
      display: flex;
      flex-direction: column;
      padding: 20px 0;
      border-top: 1px solid #f1f1f1;
      margin-top: 15px;
    }
  }
  
  /* 响应式样式 */
  @media (max-width: 1200px) {
    .footer-box {
      .column-title {
        font-size: 18px;
      }
      
      .column-item {
        font-size: 14px;
      }
      
      .company-name {
        font-size: 16px;
      }
      .logo-img {
        width: 50%;
        height: auto;
      }
    }
  }
  
  @media (max-width: 992px) {
    .footer-box {
      padding-top: 30px;
      
      .bottom-box {
        text-align: center;
        font-size: 12px;
        
        span {
          margin-bottom: 5px;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .footer-box {
      padding-top: 20px;
      
      .lines {
        margin: 20px 0;
      }
      
      .company-info-mobile {
        .company-name {
          font-size: 16px;
        }
        
        .contact-item {
          font-size: 12px;
          
          i {
            font-size: 14px;
          }
        }
      }
    }
  }
  
  @media (max-width: 480px) {
    .footer-box {
      .mobile-footer-title {
        font-size: 16px;
      }
      
      .mobile-footer-item {
        font-size: 13px;
      }
      
      .bottom-box {
        font-size: 11px;
      }
    }
  }
</style>
